export default __webpack_public_path__ + "static/media/ic_call.feb980d1.svg";